import React from 'react'

import { HeadingSmall, MetaText, ChevronRightIcon, CTALink, Image } from '@pb/components'
import { getLabelFromStorage, imageTypes } from '@pb/utils'
import cn from 'classnames'

import styles from './OrderItem.module.scss'
import { OrderItemProps } from './types'

const VISIBLE_IMAGES = 4

const getPlusItemsCount = (orderImages: OrderItemProps['orderImages'] = []): string => {
  const rest = orderImages.length - VISIBLE_IMAGES

  if (rest > 0) {
    return `+${rest}`
  }

  return ''
}

const OrderItem: React.FC<OrderItemProps> = ({
  className,
  onClick,
  isOrderCancelled = false,
  orderAmount,
  orderDate,
  orderImages,
  orderMetaData,
  orderRoute,
  orderStatus,
}) => (
  <CTALink onClick={onClick} href={orderRoute} className={cn(styles.orderWrapper, className)}>
    <div className={styles.orderItem}>
      <HeadingSmall Tag="h2" className={cn(styles.orderColumn, styles.orderStatus)}>
        {orderStatus}
      </HeadingSmall>
      <MetaText className={cn(styles.orderColumn, styles.orderMetaData)}>{orderMetaData}</MetaText>

      <MetaText
        className={cn(styles.orderColumn, styles.orderDate)}
        Tag={isOrderCancelled ? 'del' : 'span'}
      >
        <time dateTime={orderDate}>{orderDate}</time>
      </MetaText>

      <MetaText
        Tag={isOrderCancelled ? 'del' : 'span'}
        className={cn(styles.orderColumn, styles.orderAmount)}
      >
        {orderAmount}
      </MetaText>

      <span className={cn(styles.orderColumn, styles.orderImages)}>
        {orderImages?.map((imageSrc, index) =>
          index < VISIBLE_IMAGES ? (
            <Image
              key={imageSrc}
              url={imageSrc}
              altText={getLabelFromStorage('order.productDetails')}
              imageType={imageTypes.PRODUCT_IMAGE}
              className={styles.orderImage}
            />
          ) : null,
        )}
        {getPlusItemsCount(orderImages)}
      </span>
      <ChevronRightIcon className={cn(styles.orderColumn, styles.orderIcon)} />
    </div>
  </CTALink>
)

export default OrderItem
